import { Termination } from "@oysterhr/schema"
import { Maybe } from "graphql/jsutils/Maybe"
import { Button } from "@oysterhr/ui"
import { gql } from "@apollo/client"
import { useMutation, InjectedOptions } from "@oysterhr/core"

export const APPROVE_CANCELLATION_MUTATION = gql`
  mutation ApproveResignationCancellation($terminationId: ID!) {
    approveResignationCancellation(input: { terminationId: $terminationId }) {
      errors
    }
  }
`

const useApproveCancellationMutation = (options?: InjectedOptions) =>
  useMutation(APPROVE_CANCELLATION_MUTATION, options)

interface ApproveCancellationActionButtonProps {
  latestTermination: Maybe<Termination>
  refetch: () => void
}

export const ApproveCancellationButton = ({
  latestTermination,
  refetch,
}: ApproveCancellationActionButtonProps) => {
  const [approveCancellationMutation] = useApproveCancellationMutation()
  const onSubmit = async () => {
    await approveCancellationMutation({
      variables: { terminationId: latestTermination?.id },
      handlePayloadErrors: true,
    } as InjectedOptions)
    refetch()
  }

  return (
    <Button variation="secondary" onClick={onSubmit} className="mx-1">
      Approve Cancellation
    </Button>
  )
}
